import caregiverBiography from './caregiverBiography';
import main from './main';
import status from './status';

export default {
  caregiverBiography,
  main,
  status,
};
